import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { FileHandle } from '../../directives/drag.directive';

@Component({
  selector: 'app-bulk-upload-dialog',
  templateUrl: './bulk-upload-dialog.component.html',
  styleUrls: ['./bulk-upload-dialog.component.css']
})
export class BulkUploadDialogComponent implements OnInit, OnDestroy {
  excelFile: File | null = null;
  downloadTemplate: any;
  private _bulkUploadSubscription: Subscription;
  private _getTemplatesSubscription: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialogRef: MatDialogRef<any>,
    private _service: ServicecallService
  ) { }

  ngOnInit(): void {
    this._getTemplate();
  }
  ngOnDestroy(): void {
    this._bulkUploadSubscription?.unsubscribe();
    this._getTemplatesSubscription?.unsubscribe(); 
  }
  filesDropped(files: FileHandle[]): void {
    if (files.length !== 0) {
      files.forEach(element => {
        this.excelFile = element.file;
      });
    }
  }
  uploadFile(event: any) {
    if (event.target.files.length > 0) {
      this.excelFile = event.target.files[0];
    }
  }
  dialogSubmit() {
    if (this.excelFile!.size < 100) {
      this._service.toasterService({ type: 'warning', msg: 'Please try again with file size less than 100kb' });
    } else {
      this._bulkUploadSubscription = this._service.bulkUpload(this.excelFile, 'avatar').subscribe((res: any) => {
        if (res['status']) {
          this._service.toasterService({ type: 'success', msg: res['response']['message'] });
        } else {
          this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        }
        this._dialogRef.close(true);
      });
    }
  } 
  private _getTemplate() {
    this._getTemplatesSubscription = this._service.getTemplates().subscribe((resp: any) => {
      if (resp['status']) {
        this.downloadTemplate = resp['response']['data'].find((item: any) => item.module === 'users')?.templateUrl;
      } else {
        this.downloadTemplate = null;
      }
    });
  }

}
